import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Loading } from './Indicators';
import createLogger from '../../utils/createLogger';

const DEBUG = true;
const debug = createLogger(DEBUG, `InfiniteScroll.js`);

const LIST_CLASS = `list-infinite-scroll`;
const USE_CAPTURE = false;

class InfiniteScroll extends Component {
  static propTypes = {
    loadMore: PropTypes.func.isRequired,
    containerID: PropTypes.string.isRequired,
    threshold: PropTypes.number,
    hasMore: PropTypes.bool,
    loader: PropTypes.node,
    children: PropTypes.node.isRequired,
  };

  static defaultProps = {
    threshold: 250,
    hasMore: false,
    loader: null,
  };

  componentDidMount() {
    this.attachScrollListener();
  }

  componentDidUpdate() {
    this.attachScrollListener();
  }

  componentWillUnmount() {
    this.detachScrollListener();
    this.detachMousewheelListener();
  }

  getContainer = () => {
    const { containerID } = this.props;
    const node = document.getElementById(containerID);
    debug.log(`  container node:`, node);
    return node;
  };

  scrollListener = () => {
    const { loadMore, threshold } = this.props;
    const node = this.getContainer();
    const el = this.scrollComponent;

    debug.enter(`scrollListener`);
    debug.log(`  node:`, node);
    debug.log(`  el:`, el);

    let offset = el.scrollHeight - node.scrollTop - node.clientHeight;

    debug.log(`  offset:`, offset);
    debug.log(`  threshold:`, threshold);

    // Here we make sure the element is visible as well as checking the offset
    if (offset < Number(threshold) && el.offsetParent !== null) {
      debug.log(`  triggered`);

      this.detachScrollListener();
      // Call loadMore after detachScrollListener to allow for non-async loadMore functions
      if (typeof loadMore === 'function') {
        loadMore();
      }
    }
  };

  attachScrollListener = () => {
    const {
      scrollListener,
      mousewheelListener } = this;
    const { hasMore } = this.props;
    const node = this.getContainer();

    debug.enter(`attachScrollListener`);
    debug.log(`  hasMore:`, hasMore);
    debug.log(`  node:`, node);


    if (!hasMore || !node)
      return;

    node.addEventListener(
      'mousewheel',
      mousewheelListener,
      USE_CAPTURE,
    );
    node.addEventListener(
      'scroll',
      scrollListener,
      USE_CAPTURE,
    );
    node.addEventListener(
      'resize',
      scrollListener,
      USE_CAPTURE,
    );
  };

  detachScrollListener = () => {
    const node = this.getContainer();

    node.removeEventListener(
      'scroll',
      this.scrollListener,
      USE_CAPTURE,
    );
    node.removeEventListener(
      'resize',
      this.scrollListener,
      USE_CAPTURE,
    );
  };

  detachMousewheelListener = () => {
    const node = this.getContainer();

    node.removeEventListener(
      'mousewheel',
      this.mousewheelListener,
      USE_CAPTURE,
    );
  };

  mousewheelListener = (e) => {
    // Prevents Chrome hangups
    // See: https://stackoverflow.com/questions/47524205/random-high-content-download-time-in-chrome/47684257#47684257
    if (e.deltaY === 1)
      e.preventDefault();
  };


  render() {
    const {
      hasMore,
      children,
      renderProps,
    } = segregateRenderProps(this.props);

    const childrenArray = React.Children.toArray(children);

    renderProps.ref = (node) => this.scrollComponent = node;

    if (hasMore)
      childrenArray.push(<Loading key="_loader"/>);

    return React.createElement('div', renderProps, childrenArray);
  }
}

const segregateRenderProps = (props) => {
  const {
    hasMore,
    threshold,
    loadMore,
    children,
    className,
    containerID,
    ...renderProps,
  } = props;

  renderProps.className = classnames({
    [LIST_CLASS]: true,
    [className]: !!className
  });

  return {
    threshold,
    loadMore,
    hasMore,
    children,
    containerID,
    renderProps,
  };
};

export default InfiniteScroll



// WEBPACK FOOTER //
// ./src/components/static/InfiniteScroll.js